import React from 'react';
import { observer } from 'mobx-react';
import ContractProductsModal from './ContractProductsModal';
import { toJS } from 'mobx';
import { BRAZIL } from '../../../core/consts';
import ReactivateContractFormService from '../services/ReactivateContractFormService';

class ReactivateContractProductsModalContainer extends React.Component {
  render() {
    return (
      <ContractProductsModal
        options={toJS(ReactivateContractFormService.productsService.products)}
        onChange={ReactivateContractFormService.productsService.form.setValue}
        values={ReactivateContractFormService.productsService.form.getValues()}
        onSubmit={ReactivateContractFormService.productsService.handleSubmit}
        errors={ReactivateContractFormService.productsService.form.errors}
        onDelete={ReactivateContractFormService.productsService.handleDelete}
        loading={ReactivateContractFormService.productsService.fetch.fetching}
        submitting={ReactivateContractFormService.submit.fetching}
        currencyType={
          !ReactivateContractFormService.contract.country ||
          BRAZIL.includes(ReactivateContractFormService.contract.country)
            ? 'real'
            : 'dollar'
        }
        isModalOpen={ReactivateContractFormService.productsService.isModalOpen}
        isEditing={ReactivateContractFormService.productsService.isEditing}
        onReset={ReactivateContractFormService.productsService.form.reset}
        onClose={ReactivateContractFormService.productsService.handleToggleModal}
        onAddRange={ReactivateContractFormService.productsService.handleAddRange}
        onDeleteRange={ReactivateContractFormService.productsService.handleDeleteRange}
        type={ReactivateContractFormService.form.getValue('type') || toJS(ReactivateContractFormService.contract.type)}
      />
    );
  }
}

export default observer(ReactivateContractProductsModalContainer);
